import React from 'react';
import { Link } from 'react-router-dom';
import DesktopNotification from '../DesktopNotification';
import NewOfferIcon from './assets/Notifications_NewOffer.svg';

function NewOffer({
  newOffers,
  setActiveProfileTab,
  toggleRewardsModalOpen,
  ...rest
}) {
  const notificationTitle =
    newOffers.length > 1 ? 'You have new offers!' : 'You have a new offer!';
  const notificationContent =
    newOffers.length > 1
      ? 'Your new offers are ready to use!'
      : 'Your new offer is ready to use!';

  return (
    <DesktopNotification
      className="notification-new-offer"
      title={notificationTitle}
      content={notificationContent}
      iconSrc={NewOfferIcon}
      footer={
        <Link
          to="/rewards"
          className="btn btn-success notification-new-offer-button"
          onClick={e => {
            rest.onClose(rest.notificationId);
          }}
        >
          <span>Rewards</span>
        </Link>
      }
      {...rest}
    />
  );
}

export default NewOffer;
